/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Benefit$inboundSchema, Benefit$outboundSchema, } from "./benefit.js";
/** @internal */
export const WebhookBenefitUpdatedPayload$inboundSchema = z.object({
    type: z.literal("benefit.updated"),
    timestamp: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    data: Benefit$inboundSchema,
});
/** @internal */
export const WebhookBenefitUpdatedPayload$outboundSchema = z.object({
    type: z.literal("benefit.updated"),
    timestamp: z.pipe(z.date(), z.transform(v => v.toISOString())),
    data: Benefit$outboundSchema,
});
export function webhookBenefitUpdatedPayloadToJSON(webhookBenefitUpdatedPayload) {
    return JSON.stringify(WebhookBenefitUpdatedPayload$outboundSchema.parse(webhookBenefitUpdatedPayload));
}
export function webhookBenefitUpdatedPayloadFromJSON(jsonString) {
    return safeParse(jsonString, (x) => WebhookBenefitUpdatedPayload$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'WebhookBenefitUpdatedPayload' from JSON`);
}
//# sourceMappingURL=webhookbenefitupdatedpayload.js.map